import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CashierFlowType } from '../../../../types/Cashier';
import Container from '../../../Container/Container';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';
import UniqueIdPrompt from '../RMFUniqueIdPrompt/RMFUniqueIdPrompt';

import {
  TXTCLI_Cross_Operator_Deposit_Limit,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_This_is_a_monthly_limit_on_dep_ELL
} from './RMFCrossOperatorDepositLimit.messages.json';
import RMFCrossOperatorDepositLimitFields from './components/RMFCrossOperatorDepositLimitFields';

const RMFCrossOperatorDepositLimit: React.FC = () => {
  const isFirstScreen = useRmfFirstScreen();

  const {
    data: { cashierFlow }
  } = useWizardContext();

  const showBackButton = !isFirstScreen || cashierFlow === CashierFlowType.FirstDeposit;

  return (
    <Container
      page={RMFCrossOperatorDepositLimit}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />,
        buttons: { back: showBackButton }
      }}
      pageTopTitle={<Translation {...TXTCLI_Cross_Operator_Deposit_Limit} />}
      pageTopSubtitle={<Translation {...TXTWCL_This_is_a_monthly_limit_on_dep_ELL} />}
    >
      <RMFCrossOperatorDepositLimitFields />
      <UniqueIdPrompt />
    </Container>
  );
};

RMFCrossOperatorDepositLimit.displayName = 'RMFCrossOperatorDepositLimit';

export default RMFCrossOperatorDepositLimit;
